const { en: common } = require("../../common");

module.exports = {
	...common,
};
